const state = {
  freelancerCategories: [],
  sourcingRequestToken: null,
  userData: {
    companyData: null,
    productData: null,
    supplierData: null,
    paymentData: null,
  },
  currentTab: null,
  orderSummaryRecord: null
}

export default state
